<template>
  <div :class="el">
    <template v-if="variant === 2">
      <Copy size="xl" element="div" color="primaryBlue" :centered="!$matchMedia.l" bold>
        {{ $t('cs.analysis.budgetPackage.headline') }}
        <CountUp :end="totalPerYear" suffix=" €* / Jahr" />
      </Copy>
      <Copy element="div" size="m" color="primaryBlue" :centered="!$matchMedia.l">
        {{ $t('cs.analysis.budgetPackage.pg', { value: careLevel }) }}
      </Copy>
    </template>

    <template v-else>
      <Copy size="xl" element="div" centered>
        {{ $t(`cs.widget.errorText0`) }}
      </Copy>
      <Copy v-if="variant === 0" size="xl" element="div" centered>
        {{ $t(`cs.widget.errorText1`) }}
      </Copy>
    </template>

    <div :class="`${el}__inner`">
      <div :class="`${el}__row`">
        <Copy element="div" bold>{{ $t('cs.analysis.budgetPackage.approved') }}</Copy>
        <Copy :staticClass="`${el}__chart`" element="div" bold>
          <span
            :class="`${el}__progress ${el}__progress--${
              variant === 2 ? 'supportSuccess' : 'disabled'
            }`"
            :style="`width: ${variant === 2 ? approvedValueInPercent : 25}%`"
          />
          <span :class="`${el}__price`">
            <CountUp v-if="variant === 2" :end="approvedValue" suffix=" €" />
            <template v-else>?</template>
          </span>
        </Copy>
      </div>
      <div :class="`${el}__row`">
        <Copy element="div" bold>{{ $t('cs.analysis.budgetPackage.desired') }}</Copy>
        <Copy :staticClass="`${el}__chart`" element="div" bold>
          <span
            :class="`${el}__progress ${el}__progress--${
              variant === 2 ? 'supportWarning' : 'disabled'
            }`"
            :style="`width: ${variant === 2 ? desiredValueInPercent : 75}%`"
          />
          <span :class="`${el}__price`">
            <CountUp v-if="variant === 2" :end="desiredValue" suffix=" €" />
            <template v-else>?</template>
          </span>
        </Copy>
      </div>
    </div>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import CountUp from '@/objects/CountUp';

import mixin from '@/mixins/careService';

export default {
  name: 'CareServiceBudgetPackageWidget',
  mixins: [mixin],
  props: {
    variant: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Copy,
    CountUp,
  },
  data() {
    return {};
  },
};
</script>
